import { LoanApplicationSubmitSource2 } from '@servicetitan/financing-api-client';
import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        __IS_SETUP_DATA_STORE_CREATED?: boolean;
        SetupDataStore?: any;
    }
}

export interface SetupData {
    provider: string;
    tenantId: string;
    technicianId: string;
    jobId: string | null;
    buId: string;
    customerId: string;
    state?: string;
    isInSecondLook?: boolean;
    source?: LoanApplicationSubmitSource2;
    useInAppBrowser?: boolean;
    role?: 'homeowner' | 'technician';
    prequalificationId?: string;
    loanId?: string;
    isApplyingForPrequalification?: boolean;
    hasTransitionedToHardApp?: boolean;
    referrer?: string;
}

function useSetupData(initialState: SetupData | null = null) {
    const [setupData, setSetupData] = useState(initialState);
    return { setupData, setSetupData };
}

// if (!window.__IS_SETUP_DATA_STORE_CREATED) {
export const SetupDataStore = createStore(useSetupData);
// window.__IS_SETUP_DATA_STORE_CREATED = true;
// }

// export const SetupDataStore = window.SetupDataStore;
